export { getLogger, rootLogger } from "./logger";
export { getLogContext, setLogContextProvider } from "./context";
export type { LogContext, LogContextProvider } from "./context";
export {
  isServer,
  isNodeServer,
  isLocalScript,
  isNextEdgeRuntime,
  createDatadogLocalTransport,
} from "./utils";

export type { Logger } from "pino";
